import type { PostCallAnalysisConfig } from './types';

export const defaultCallAnalysisConfig: PostCallAnalysisConfig = {
  kpis: [
    {
      id: 'total_calls',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.totalCalls',
      formula: { type: 'total' },
      format: 'number',
    },
    {
      id: 'completion_rate',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.completionRate',
      formula: {
        type: 'ratio',
        numerator: { type: 'count', field: 'status', value: 'ended' },
        denominator: { type: 'total' },
      },
      format: 'percent',
    },
    {
      id: 'customer_hangup_rate',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.customerHangupRate',
      formula: {
        type: 'ratio',
        numerator: { type: 'count', field: 'endedReason', value: 'customer-ended-call' },
        denominator: { type: 'count', field: 'status', value: 'ended' },
      },
      format: 'percent',
    },
    {
      id: 'avg_call_duration',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.avgCallDuration',
      formula: { type: 'avg_duration', startField: 'startedAt', endField: 'endedAt' },
      format: 'duration',
    },
    {
      id: 'unreachable_rate',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.unreachableRate',
      formula: {
        type: 'ratio',
        numerator: {
          type: 'countIn',
          field: 'endedReason',
          values: ['customer-busy', 'customer-unavailable', 'customer-did-not-join'],
        },
        denominator: { type: 'total' },
      },
      format: 'percent',
    },
    {
      id: 'error_rate',
      path: 'calls',
      label: 'campaignPage.analysisSummary.kpis.errorRate',
      formula: {
        type: 'ratio',
        numerator: {
          type: 'countIn',
          field: 'endedReason',
          values: [
            'internal-error',
            'unknown-reason',
            'error-sip-telephony-provider-failed-to-connect-call',
            'transfer-failed',
          ],
        },
        denominator: { type: 'total' },
      },
      format: 'percent',
    },
  ],
  charts: [
    {
      id: 'call_status',
      path: 'calls',
      type: 'pie',
      title: 'campaignPage.analysisSummary.charts.callStatus',
      field: 'status',
      maxCategories: 8,
    },
    {
      id: 'sentiment_distribution',
      path: 'calls',
      type: 'bar',
      title: 'campaignPage.analysisSummary.charts.sentimentDistribution',
      field: 'sentiment',
      mapper: 'extractSentiments',
      maxCategories: 5,
    },
    {
      id: 'end_reason',
      path: 'calls',
      type: 'barHorizontal',
      title: 'campaignPage.analysisSummary.charts.endReason',
      field: 'endedReason',
      excludeValues: ['—'],
      maxCategories: 10,
    },
    {
      id: 'call_duration',
      path: 'calls',
      type: 'bar',
      title: 'campaignPage.analysisSummary.charts.callDuration',
      field: 'durationBucket',
      mapper: 'extractDurationBuckets',
      maxCategories: 5,
    },
  ],
};
